import React from "react";
import { boundError } from "../utils";

const WalletAddressQRCodeRaw = ({ size = 300, address }) => {
  const baseUrl = `https://chart.googleapis.com/chart`;
  return <img src={`${baseUrl}?chs=${size}x${size}&cht=qr&chl=${address}&choe=UTF-8">`} />;
};

export const WalletAddressQRCode = boundError(WalletAddressQRCodeRaw);
